import { loincCoding } from '#src/models/loinc.ts'
import {
  GAD7_WORRY_CONTROL_ANSWERS,
  PHQ_FREQUENCY_ANSWERS,
} from '#src/terminology/instruments/instrumentTerminology.ts'
import { PHQ_COPYRIGHT } from '#src/terminology/instruments/phq9.ts'
import {
  ownCoding,
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

// The first two GAD-7 questions, answered as the GAD-7 answers them, so a
// GAD-2 answer and a GAD-7 answer to the same question read the same.
const SECTIONS: InstrumentSection[] = [
  {
    id: 'items',
    items: [
      scoredItem(
        loincCoding('69725-0', 'Feeling nervous, anxious or on edge'),
        PHQ_FREQUENCY_ANSWERS
      ),
      scoredItem(
        loincCoding(
          '68509-9',
          'Over the past 2 weeks have you not been able to stop or control worrying'
        ),
        GAD7_WORRY_CONTROL_ANSWERS
      ),
    ],
  },
]

// LOINC has no GAD-2 panel or total, so both are our own codes.
export const GAD2_TEMPLATE: InstrumentTemplate = {
  id: 'gad-2',
  version: '1',
  panel: ownCoding(
    'gad-2-panel',
    'Generalized anxiety disorder 2 item (GAD-2)'
  ),
  title: 'Generalized anxiety disorder 2 item (GAD-2)',
  shortName: 'GAD-2',
  copyright: PHQ_COPYRIGHT,
  reference: 'https://www.hiv.uw.edu/page/mental-health-screening/gad-2',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'gad-2',
    coding: ownCoding('gad-2-total', 'GAD-2 total score'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [
      scoreBand(
        { min: 0, max: 2 },
        'gad-2-negative',
        'Screen Negative',
        'green'
      ),
      scoreBand(
        { min: 3 },
        'gad-2-positive',
        'Screen Positive (Anxiety Disorder Possible)',
        'red'
      ),
    ],
  }),
}
